export default "__VITE_ASSET__a2f42826__"